export default ({ color = "#DA1F1F", ...props }) => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.93371 0.702516C6.10451 0.29187 6.68624 0.291869 6.85704 0.702516L8.26187 4.08014C8.33387 4.25326 8.49668 4.37154 8.68357 4.38652L12.33 4.67886C12.7733 4.7144 12.9531 5.26765 12.6153 5.55699L9.83713 7.9368C9.69473 8.05878 9.63255 8.25017 9.67605 8.43255L10.5248 11.9908C10.628 12.4235 10.1574 12.7654 9.77785 12.5336L6.656 10.6267C6.49599 10.529 6.29476 10.529 6.13475 10.6267L3.0129 12.5336C2.63335 12.7654 2.16272 12.4235 2.26592 11.9908L3.1147 8.43255C3.1582 8.25017 3.09602 8.05878 2.95362 7.93681L0.17543 5.55699C-0.162339 5.26765 0.0174234 4.7144 0.46075 4.67886L4.10718 4.38652C4.29407 4.37154 4.45688 4.25326 4.52888 4.08014L5.93371 0.702516Z"
      fill={color}
    />
  </svg>
);
